import { type ChangeEvent, type FC, type KeyboardEvent, type RefObject } from "react";

import { Flexbox } from "../../shared/components";
import { inputStyles } from "../../shared/styles";

import { InputContainer, addButtonContainerStyle, addTagButtonStyle } from "./Tags.styles";

interface TagsInputProps {
    inputRef: RefObject<HTMLInputElement>;
    onInputTagChange: (event: ChangeEvent<HTMLInputElement>) => void;
    onAddTag: (name: string) => void;
    placeholder: string;
}

export const TagsInput: FC<TagsInputProps> = ({ onAddTag, onInputTagChange, placeholder, inputRef }) => {
    const minTagLength = 3;
    const maxTagLength = 15;

    const handleKeydownEvent = (event: KeyboardEvent<HTMLInputElement | HTMLDivElement>) => {
        const inputElement = inputRef.current;
        if (!inputElement) {
            return;
        }
        if (event.key === "Enter") {
            onAddTag(inputElement.value);
        }
    };

    const handleClickEvent = () => {
        const inputElement = inputRef.current;
        if (!inputElement) {
            return;
        }
        onAddTag(inputElement.value);
    };

    return (
        <InputContainer>
            <input
                type="text"
                pattern="[a-zA-Z0-9\-]+"
                minLength={minTagLength}
                maxLength={maxTagLength}
                className={inputStyles}
                ref={inputRef}
                placeholder={placeholder}
                data-testid="tags-input"
                onChange={onInputTagChange}
                onKeyDown={handleKeydownEvent}
            />
            <Flexbox alignItems="center" className={addButtonContainerStyle}>
                <div
                    onKeyDown={handleKeydownEvent}
                    onClick={handleClickEvent}
                    role="button"
                    tabIndex={0}
                    className={addTagButtonStyle}
                    data-testid="tags-button"
                >
                    Add tag
                </div>
            </Flexbox>
        </InputContainer>
    );
};
